<template>
    <div class="container align-center">
        <div class="flex align-center">
            <span class="item header">Zeitraum auswählen: </span>
            <date-selection-combo class="item flex align-center" :is-fourteen="true" id="adatable-datepicker"
                                  v-bind="$attrs"
            ></date-selection-combo>
        </div>
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import DateSelectionCombo from "./DateSelectionCombo";

export default {
    name: "DateSelectionContainer",
    components: {DateSelectionCombo},
    data() {
        return {
            range: {
                start: {},
                end: {}
            }
        };
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    display: flex;
    background: #fff;
    padding: 15px;
    align-items: center;
    margin-bottom: 10px;
    justify-content: space-between;
}

.item {
    display: inline-block;

  :deep( .infoBubble) {
        margin-bottom: 0 !important;
    }
}

.header {
    font-weight: bold;
}

.slot {
    display: flex;
    justify-self: right;
}

.flex {
    display: flex;
}

.align-center {
    align-items: center;
}

</style>